import { atomFamily } from "jotai/utils";

import { PointOfImpactGlass } from "types/DigitalJourneySession";

import { createDerivedSessionAtom } from "./utils/createDerivedSessionAtom";
import { createPersistedAtom } from "./utils/createPersistedAtom";

export const sessionWindowsPOIAtom = atomFamily((sessionId: string) =>
  createPersistedAtom<PointOfImpactGlass[]>(`windowsPOI-${sessionId}`, [])
);
export const windowsPOIAtom = createDerivedSessionAtom<PointOfImpactGlass[]>(sessionWindowsPOIAtom);
